import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const getSearchThemeDetails = (i18n, searchThemes) => {
  if (searchThemes && searchThemes.length > 0) {
    return searchThemes.map(item => item.SearchTheme).join(', ');
  }
  return i18n.getString(_TL_('No search themes added'));
};

export const SearchThemes = ({ data }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Search themes') }}>
      <Text>{getSearchThemeDetails(i18n, data)}</Text>
    </PropertyRow>
  );
};

SearchThemes.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string),
};

SearchThemes.defaultProps = {
  data: [],
};
